export default "__VITE_ASSET__DrlU8BXB__"